import { Component, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Observable, take, tap } from 'rxjs';
import { ITitlePage } from 'src/app/shared/misc/title-page';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ShipmentsTableComponent } from '../../components/shipments-table/shipments-table.component';
import { Shipment } from '../../shared/models/shipment';
import { ShipmentsApiService } from '../../shared/services/shipments-api.service';

@Component({
  selector: 'app-tracking',
  imports: [
    ShipmentsTableComponent
  ],
  templateUrl: './tracking.component.html',
  styleUrl: './tracking.component.scss'
})
export class TrackingComponent implements ITitlePage {
  readonly title = signal<string>("Mina försändelser");

  private readonly apiService = inject(ShipmentsApiService);
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);

  shipments = signal<Shipment[]>([]);
  columns = computed<(keyof Shipment)[]>(() => {
    if (this.authService.isInRole('FullTrackers')) {
      return ['AssignedTimestamp', 'Courier', 'ShipmentId', 'SalesPersonId', 'SalesPersonName',
        'CompanyName', 'PoNumber', 'CreditNumber', 'Status'];
    }
    return ['AssignedTimestamp', 'Courier', 'ShipmentId', 'Status'];
  });
  isLoading = computed(() => this.apiService.isLoading());

  constructor() {
    this.route.paramMap.pipe(
      takeUntilDestroyed(),
      tap(params => {
        let request: Observable<Shipment[]> | null = null;
        const filter = params.get('filter');

        switch (filter) {
          case "my-shipments":
            request = this.apiService.getTrackedShipments('my');
            break;
          case "history":
            this.title.set("Historik");
            request = this.apiService.getTrackedShipments('all');
            break;
        }

        request?.pipe(
          take(1),
          tap(shipments => this.shipments.set(shipments))
        ).subscribe();
      })
    ).subscribe();
  }
}
